import React, { useState } from 'react';
import { Breadcrumb } from 'xland-ui';
import Table from 'components/Table';
import { Eye } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useCounter } from 'utils/customHooks';
import { formatDate, formatTime } from 'utils/functions';
import { getScriptLogs } from './actions';
import ScriptLogDetails from './scriptLogDetails';

function AdminScripts() {
  const literals = useSelector(state => state.i18n.literals.admin.scripts);
  const literalsCommon = useSelector(state => state.i18n.literals.common);

  const [detailsPopup, setDetailsPopup] = useState(false);
  const tableRefreshFlag = useCounter(0);

  const columns = [
    {
      field: 'name',
      label: literalsCommon.name,
      classes: 'fc-highest border-right',
    },
    {
      field: 'runtime',
      label: literals.runtime,
      preRender: date => formatTime(date, 'seconds', 4),
      width: 120,
      align: 'end',
    },
    {
      field: 'createdAt',
      label: literalsCommon.createdAt,
      preRender: date => formatDate(date, { time: true }),
      width: 120,
      align: 'end',
    },
    {
      field: 'id',
      type: 'button',
      button: {
        icon: Eye,
        text: literalsCommon.view,
        onClick: setDetailsPopup,
      },
    },
  ];

  return (
    <>
      <Breadcrumb routes={[{ name: 'Logs' }, { name: literals.title }]} />
      <Table
        columns={columns}
        onClickRow={setDetailsPopup}
        fetch={getScriptLogs}
        forceFetch={tableRefreshFlag.value}
      />
      {detailsPopup && (
        <ScriptLogDetails
          literals={literals}
          literalsCommon={literalsCommon}
          script={detailsPopup}
          onClose={() => setDetailsPopup(false)}
        />
      )}
    </>
  );
}

export default AdminScripts;
